export default __webpack_public_path__ + "static/media/kaaf-slider-img-2.3b31ea34.png";